// The woosh when he enters or leaves a call (QUEUE row 460; Adam, 2026-10-19:
// "make a woosh sound play when i enter or exit the room, and make the sound
// slightly different for enter/exit"). Made from filtered noise rather than a
// file, so there is nothing to load: entering sweeps up, leaving sweeps down
// and ends a little sooner.

let ctx: AudioContext | null = null;

function context(): AudioContext | null {
  if (ctx) return ctx;
  const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  try {
    ctx = new Ctor();
  } catch {
    return null;
  }
  return ctx;
}

export function playWhoosh(kind: "enter" | "exit"): void {
  const ac = context();
  if (!ac) return;
  void ac.resume().catch(() => {});
  const length = kind === "enter" ? 0.55 : 0.45;
  const frames = Math.ceil(ac.sampleRate * length);
  const buffer = ac.createBuffer(1, frames, ac.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < frames; i++) data[i] = Math.random() * 2 - 1;

  const source = ac.createBufferSource();
  source.buffer = buffer;
  const filter = ac.createBiquadFilter();
  filter.type = "bandpass";
  filter.Q.value = 1.4;
  const gain = ac.createGain();
  const t = ac.currentTime + 0.02;
  const [from, to] = kind === "enter" ? [350, 2600] : [2200, 300];
  filter.frequency.setValueAtTime(from, t);
  filter.frequency.exponentialRampToValueAtTime(to, t + length);
  gain.gain.setValueAtTime(0.0001, t);
  gain.gain.exponentialRampToValueAtTime(0.32, t + length * (kind === "enter" ? 0.55 : 0.3));
  gain.gain.exponentialRampToValueAtTime(0.0001, t + length);

  source.connect(filter).connect(gain).connect(ac.destination);
  source.start(t);
  source.stop(t + length + 0.05);
}

// The ding when someone joins the waiting room (QUEUE row 480; Adam,
// 2026-10-30: "i want a ding sound when someone joins the waiting room").
// Two sine partials with a quick attack and a short ring-out, from the same
// context as the woosh.
export function playDing(): void {
  const ac = context();
  if (!ac) return;
  void ac.resume().catch(() => {});
  const t = ac.currentTime + 0.02;
  const out = ac.createGain();
  out.gain.setValueAtTime(0.0001, t);
  out.gain.exponentialRampToValueAtTime(0.35, t + 0.015);
  out.gain.exponentialRampToValueAtTime(0.0001, t + 1.1);
  out.connect(ac.destination);
  for (const [freq, level] of [[988, 1], [1480, 0.45]] as const) {
    const osc = ac.createOscillator();
    const g = ac.createGain();
    osc.type = "sine";
    osc.frequency.value = freq;
    g.gain.value = level;
    osc.connect(g).connect(out);
    osc.start(t);
    osc.stop(t + 1.15);
  }
}
